import * as yup from 'yup'
import { TYPE_REQUIRED, LOCATION_INVALID } from 'constants/errors'
import { zipCodeSchema, usernameSchema } from 'helpers/schemaHelpers'

export const profileEditSchema = yup.object().shape({
  username: usernameSchema,
  avatar: yup.number().nullable(true).notRequired(),
  income: yup.mixed().required(TYPE_REQUIRED),
  housing_type: yup.mixed().required(TYPE_REQUIRED),
  address1: yup.mixed(),
  address2: yup.mixed(),
  city: yup.object().shape({
    id: yup.number().typeError(LOCATION_INVALID),
  }).typeError(LOCATION_INVALID),
  zip5: zipCodeSchema,
})
